import React, { useEffect, useState } from 'react';
import { whatTypeIsIt } from './utils';

function JsonEdit(props) {

    const { value, edit } = props;
    const [valueObj, setValueObj] = useState();

    useEffect(() => {
        try {
            const obj = JSON.parse(value);
            setValueObj(obj);
        } catch {
            console.error('no hay json válido');
        }
    }, []);

    const renderString = (name, value) => {
        return (
            <div>
                {name}:{edit ? <input value={value || ''} /> : value}
            </div>
        )
    }

    const RenderShow = (obj) => {
        const keys = Object.keys(obj);
        return keys.map(o => {
            switch (whatTypeIsIt(obj[o])) {
                case 'String':
                    return renderString(o, obj[o]);
                case 'Object':
                    return <div><div>{o}</div><div>{RenderShow(obj[o])}</div></div>
                case 'Array':
                    return <div><div>{o}</div><div>{obj[o].map(so => RenderShow(so))}</div></div>
                default:
                    break;
            }
        }
        )
    }

    return (
        <div>
            {valueObj && RenderShow(valueObj)}
        </div>
    );
}

export default JsonEdit;